<template>
  <b-container>
    <AccordionText
      v-for="accordion in accordions"
      :key="accordion.id"
      :id="accordion.id"
      :title="accordion.title"
      :text="accordion.text"
    ></AccordionText>
  </b-container>
</template>

<script>
import AccordionText from "../../components/AccordionText";

export default {
  data() {
    return {
      accordions: [
        {
          title: "Le strabisme",
          id: "strabisme",
          text: `#### Définition
Le strabisme est un défaut de parallélisme de l’axe des 2 yeux, qui se traduit par la déviation d’un oeil. On parle de strabisme convergent quand l’œil est dévié vers le nez ; de strabisme divergent quand l’œil est dévié vers l’oreille; de strabisme vertical quand l’œil est dévié vers le haut ou vers le bas.

![Strabisme](/prisesEnChargeImages/image3.jpg)
*Strabismes*

#### Symptômes
Un strabisme peut apparaître à n’importe quel âge
Il peut être constant ou intermittent, il n’apparaît alors que de temps en temps dans la journée, surtout lorsque votre enfant est fatigué ou en fin de journée.
Il peut provoquer une amblyopie de l’oeil dévié.

#### Traitement

- Les lunettes: Le port de lunettes adaptées est essentiel dans le traitement du strabisme et dans la prévention de l’amblyopie. Elles sont à porter toute la journée pour stabiliser la vision et le strabisme 
- Le traitement de l’amblyopie (ci dessous)
- La rééducation, selon le type de strabisme de votre enfant, la rééducation orthoptique peut aider à diminuer le strabisme. 
- L’ injection de toxine botulique dans les muscles oculomoteurs. 
- La chirurgie des muscles permet la réduction du strabisme.`
        },
        {
          title: "L'amblyopie",
          id: "amblyopie",
          text: `
#### Définition
La vision se développe à partir de la naissance. Si pendant l’enfance le cerveau reçoit une image floue d’un œil, il aura tendance à ne pas le solliciter. Le développement visuel ne sera donc pas optimisé et le cerveau ne fera pas les connexions neuronales nécessaires pour une vision de qualité. L’oeil devient « paresseux », et est alors qualifié d’"amblyope".
L’amblyopie peut atteindre un oeil ou les deux yeux. Si l’atteinte est unilatérale, l’oeil sain continue de se développer.
La cause est le plus souvent rapportée à un problème de réfraction (lunettes) ou un strabisme d’un seul œil. D’autres causes organiques plus rares existent (cataracte, nystagmus…).
#### Symptômes
En cas d’atteinte unilatérale l’enfant ne se plaint de rien. Le parent n’a aucun signe d’alerte (sauf si la raison est un strabisme) et l’atteinte peut passer inaperçue, d’où l’intérêt du dépistage systématique (9 mois, 3 ans, 6 ans).
En cas d’atteinte bilatérale l’enfant montrera des signes de gêne visuelle (force pour voir, se rapproche beaucoup, yeux rouges et larmoiements après efforts visuels: dessins, lecture TV)
#### Traitements
L’amblyopie peut être traitée durant la période de développement de la vision, soit pendant les 6 premières années de vie. Au delà de cette période critique, l’amblyopie non traitée risque de devenir définitive.
Le traitement consiste à porter les lunettes avec la correction optique totale, et en même temps à pénaliser de manière dosée l’oeil sain par des traitements jusqu’à récupération visuelle de l’oeil amblyope.
La correction optique totale, et la correction de tous les défauts amétropiques (astigmatisme, hypermétropie, myopie) que l’on retrouve avec une réfraction sous cycloplégique (atropine ou cyclopentolate =Skiacol).
Les méthodes de traitement utilisées ont pour but de lutter contre la dominance de l’œil sain et stimuler l’œil malade.
La plus efficace est l'occlusion par caches oculaires. Des pénalisations optiques ou des filtres ryser peuvent être proposés dans les lunettes dans un second temps. Des exercices peuvent être proposés en complément.
Le traitement est très efficace avant six ans (Excellent résultat avant 2 ans =99 %, très bon résultat avant 6 ans =90 %, échec fréquent après huit ans mais des tentatives peuvent être proposées). Il est toutefois inutile de le commencer à l’âge adulte.

![Cache](/prisesEnChargeImages/image19.jpg)
*Enfant avec un cache*
`
        }
      ]
    };
  },
  components: {
    AccordionText
  }
};
</script>s